"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pdpUrlQuery = void 0;
var _fetching = require("@ori/fetching");
/* istanbul ignore file */

const pdpUrlQuery = exports.pdpUrlQuery = (0, _fetching.gql)`
  query PdpUrl($productCode: ID!, $storeName: ID) {
    product(productCode: $productCode) {
      pdpUrl {
        title
        relativeUrl
        dynamicSharingUrl(storeName: $storeName)
      }
    }
  }
`;
